/**
 * Copyright 2026 Perform Content Services Limited. Confidential and Proprietary. All Rights Reserved.
 */
import * as styled from 'styled-components';
import {theme, paddings} from 'components/shared/theme';

const {
  colors,
  fontSizeS,
  primaryBackground
} = theme;

export const Table = styled.default.table`
  width: 100%;
  border-collapse: collapse;
  margin: 0;
  table-layout: fixed;
`;

export const Thead = styled.default.thead`
  color: ${colors.white};
  & tr {
    vertical-align: middle;
    border: none;
    & th {
      top: -1px;
      background-color: ${primaryBackground};
      padding: ${paddings.small} 0;
      z-index: 10;

      &:last-child {
        border: none;
      }
    }
  }
`;

export const TH = styled.default.th<{active?: boolean; border?: boolean; width?: number}>`
  color: ${({active}) => (active ? colors.white : colors.gray500)};
  font-size: ${fontSizeS};
  cursor: pointer;
  border: 1px solid transparent;
  border-right-color: ${colors.gray700};
  & span {
    margin-left: .4rem;
  }
`;

export const Tbody = styled.default.tbody`
  tr:nth-child(odd) {
    background: ${colors.gray800};
  }
  & tr {
    border-color: transparent transparent ${colors.black} transparent;
    height: 3rem;
    & td {
      color: ${colors.white};
      padding: ${paddings.small};
      word-wrap: break-word;
      font-size: ${fontSizeS};
      position: relative;
      text-align: center;

      & > div,
      & > p {
        text-align: center;
        justify-content: center;
      }

      & a {
        color: ${theme.linkColor};
        text-decoration: none;
      }
    }
  }
`;